export default "__VITE_ASSET__CtqOiQlQ__"